import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnsiteBloggingService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/onsiteblogging`;

  constructor(private http: HttpClient) {}

  getImplementationSummary(taskId: number): Observable<Boo.Objects.OnsiteImplementation.OnsiteBloggingImplementationSummary> {
    const params = new HttpParams().set('taskId', taskId);

    return this.http.get<Boo.Objects.OnsiteImplementation.OnsiteBloggingImplementationSummary>(`${this.baseUrl}/ImplementationSummary`, { params: params });
  }
}
